import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Styles/MobileResponsive.css';
import './Styles/Animations.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Loaded last on purpose: phone-only overrides, see the file header.
import './Styles/MobileRefine.css';
// Tablet + phone layout fixes, all capped at 1024px.
import './Styles/TabletRefine.css';

// Guard against third-party analytics/widget runtime crashes
window.addEventListener('error', (event) => {
  if (
    event?.filename?.includes('tawk') || 
    event?.message?.includes('Tawk') || 
    event?.message?.includes('i18next') ||
    event?.filename?.includes('contentsquare')
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();